module.exports = __webpack_public_path__ + "static/media/bg.eca0dcba.png";